"use client";

import { useRouter } from "next/navigation";
import { useLocale } from "next-intl";
import { useTransition } from "react";

import { LOCALE_COOKIE, LOCALES, LOCALE_LABELS, type Locale } from "@/lib/i18n/config";

// The signed-out language picker (landing page and the login / password pages'
// footers, via LegalLinks). It only writes the cp_locale cookie and re-renders
// the route; lib/i18n/request.ts reads that cookie while there's no session.
// Signed in, the account's stored language wins and the Profile / account menu
// picker is the one to use.
export function PublicLocaleSwitcher({ label }: { label: string }) {
  const currentLocale = useLocale() as Locale;
  const router = useRouter();
  const [pending, startTransition] = useTransition();

  function handleChange(locale: Locale) {
    if (locale === currentLocale) return;
    document.cookie = `${LOCALE_COOKIE}=${locale}; path=/; max-age=31536000; samesite=lax`;
    startTransition(() => router.refresh());
  }

  return (
    <select
      aria-label={label}
      value={currentLocale}
      disabled={pending}
      onChange={(e) => handleChange(e.target.value as Locale)}
      className="rounded-md border border-border bg-background px-2 py-1 text-xs text-muted-foreground hover:text-foreground focus:outline-none focus:ring-2 focus:ring-primary/30"
    >
      {LOCALES.map((locale) => (
        <option key={locale} value={locale} lang={locale}>
          {LOCALE_LABELS[locale]}
        </option>
      ))}
    </select>
  );
}
